// export const MAX_WORD_LENGTH = 9;
export const MAX_CHALLENGES = 6;
export const ALERT_TIME_MS = 2000;
export const REVEAL_TIME_MS = 200;
export const GAME_LOST_INFO_DELAY = (9 + 1) * REVEAL_TIME_MS;
